export default "__VITE_ASSET__B2O2obz8__"